<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import accionesCorrectivasPreventivasAPI from "../../../services/standards/accionesCorrectivasPreventiavs/accionesCorrectivasPreventivasAPI";
import employeeAPI from "../../../services/employee/employeeAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "7.1.1 Acciones correctivas y/o preventivas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "7.1.1 Acciones correctivas y/o preventivas",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Acciones correctivas y/o preventivas",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      lista: [],
      loading: true,
      usersList: [],
      list: [],

      item: null,
      search: "",
      file: null,
      submitted: false,
      itemData: null,

      acciones: {
        detection_date: null,
        area: null,
        evaluator: null,
        causes: null,
        action_type: null,
        description_action_plan: null,
        scheduled_date: null,
        actual_state: null,
        execution_date: null,
        observation: null,
        file: null,
        corrective_actions_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  validations: {
    acciones: {
      detection_date: {
        required,
      },
      evaluator: {
        required,
      },
      action_type: {
        required,
      },
      actual_state: {
        required,
      },
      corrective_actions_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(57)//57-58-59-60
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 57)//57-58-59-60
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let name = "";
        let url = "";

        if (!this.file) {
          if (this.acciones.file) {
            name = this.getFile(this.acciones.file);
          } else {
            throw new Error("No se ha seleccionado un archivo y no hay un archivo previo.");
          }
        } else {
          name = this.file.name;
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/7.1.1-4/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/7.1.1-4/${this.$route.params.id}/${name}`;
        }

        if (!this.file) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.acciones.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error.message || error);
        return false;
      }
    },

    getUsers() {
      employeeAPI
        .getEmployeesOcupationalMedical(this.companyID)
        .then((res) => {
          this.usersList = res.employee;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getListA() {
      accionesCorrectivasPreventivasAPI
        .getList()
        .then((response) => {
          this.list = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getShow() {
      accionesCorrectivasPreventivasAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.acciones = {
            detection_date: response.data.detection_date,
            area: response.data.area,
            evaluator: response.data.evaluator,
            causes: response.data.causes,
            action_type: response.data.action_type,
            description_action_plan: response.data.description_action_plan,
            scheduled_date: response.data.scheduled_date,
            actual_state: response.data.actual_state,
            execution_date: response.data.execution_date,
            observation: response.data.observation,
            file: response.data.file,
            corrective_actions_id: response.data.corrective_actions_id,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true;
      this.loading = true;

      try {
        // Subir el documento
        const response = await this.uploadDocument();
        if (!response) {
          this.showAlert("¡Error!", "¡No se ha podido actualizar!", "warning", "warning");
          this.loading = false;
          return;
        }

        // Actualizar acción
        await accionesCorrectivasPreventivasAPI.update(this.$route.params.id, {
          detection_date: this.acciones.detection_date,
          area: this.acciones.area,
          evaluator: this.acciones.evaluator,
          causes: this.acciones.causes,
          action_type: this.acciones.action_type,
          description_action_plan: this.acciones.description_action_plan,
          scheduled_date: this.acciones.scheduled_date,
          actual_state: this.acciones.actual_state,
          execution_date: this.acciones.execution_date,
          observation: this.acciones.observation,
          file: this.acciones.file,
          corrective_actions_id: this.acciones.corrective_actions_id,
          employee_id: this.acciones.employee_id,
          companies_id: this.acciones.companies_id,
        });

        // IDs para actualizar
        const itemIds = [57, 58, 59, 60];
        const newStatus = "Pendiente"; // Ajusta el estado según sea necesario

        // Actualizar estados para los IDs
        const updatePromises = itemIds.map((itemId) => {
          const itemChange = {
            companies_id: this.acciones.companies_id,
            item_id: itemId,
            status: newStatus,
          };
          return newScoresAPI.calculateScores(itemChange);
        });

        await Promise.all(updatePromises);

        // Mostrar éxito
        this.showAlert("¡Éxito!", "¡Información actualizada con éxito!", "success", "success");
        this.$router.go(-1);
      } catch (error) {
        console.error(error);
        this.showAlert("¡Error!", "¡No se ha podido actualizar!", "error", "error");
      } finally {
        this.loading = false;
      }
    },

    // Función para mostrar alertas
    showAlert(title, text, icon, type) {
      Swal.fire({
        title,
        text,
        icon,
        type,
        confirmButtonClass: "btn btn-confirm mt-2",
        buttonsStyling: false,
      });
    },

    getList() {
      accionesCorrectivasPreventivasAPI
        .getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getItems();
    this.getList();
    this.getListA();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Fuente de acción">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.corrective_actions_id">
                      <b-form-select-option v-for="item in list" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha detección" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.detection_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Área" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" maxlength="50"
                      v-model="acciones.area">
                    </b-form-input>

                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Evaluador" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" maxlength="50"
                      v-model="acciones.evaluator">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Causas" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" maxlength="200"
                      v-model="acciones.causes">
                    </b-form-textarea>
                  </b-form-group>

                  <h5 class="col-md-12 px-2 pt-2">Planes de acción</h5>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3 pt-3" label="Tipo de acción">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.action_type">
                      <b-form-select-option value="Preventiva">
                        Preventiva
                      </b-form-select-option>
                      <b-form-select-option value="Correctiva">
                        Correctiva
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción plan de Acción" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate" maxlength="200"
                      v-model="acciones.description_action_plan">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha programada" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.scheduled_date">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha real de ejecución" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.execution_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Responsable">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Estado actual">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.actual_state">
                      <b-form-select-option value="Abierta">
                        Abierta
                      </b-form-select-option>
                      <b-form-select-option value="Cerrada">
                        Cerrada
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" maxlength="200"
                      v-model="acciones.observation">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="acciones.file ? getFile(acciones.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
